const baseRoute = 'solventa'
const homeBase = `${baseRoute}/home`

export const LEVEL_1_ROUTES = {
  INVITATION: `${baseRoute}/invitation/confirmation`,

  FIRST_TIME: `${homeBase}/first-time`,
  EVALUATION_LOAN_REQUEST: `${homeBase}/evaluating-loan-request`,
  LOAN_REQUEST_DENIED: `${homeBase}/loan-request-denied`,
  // LOAN_REQUEST_ACCEPTED: `${homeBase}/loan-request-accepted`,
  EVALUATING_LOAN: `${homeBase}/evaluating-loan`,
  DECLINED_LOAN: `${homeBase}/loan-declined`,
  ACTIVE_LOAN: `${homeBase}/active-loan`,
  EVALUATING_PAYMENT: `${homeBase}/active-loan`,
  PAYMENT_DECLINED: `${homeBase}/active-loan`,
  SETTING_CUSTOM_CREDIT: `${homeBase}/active-loan`,
  WAITING_LOAN: `${homeBase}/waiting-loan`,

  /* LEVEL 1 ROUTES */
  FRAUD_QUESTIONNAIRE: `${homeBase}/resume-questionnaire`,
  KYC_REQUEST: `${homeBase}/loan-request-accepted`, // THEN THE USER GOES TO KYC REQUEST ROUTE (/kyc-request)
  KYC_REQUEST_DENIED: `${baseRoute}/kyc-request?status=denied`,
  EVALUATING_KYC: `${homeBase}/evaluating-kyc`,
  LOAN_REQUEST: `${homeBase}/kyc-request-accepted`, // THEN THE USER GOES TO REQUEST LOAN MODULE ROUTE (/request-loan-module)
  SOLVENTA: `${homeBase}/solventa`,

  /* LEVEL 1 NOT APPLICABLE STATES */
  USER_NOT_APPLICABLE: `${homeBase}/not-applicable/user-not-applicable`,
  USER_KYC_NOT_APPLICABLE: `${homeBase}/not-applicable/user-kyc-not-applicable`,
  USER_LOAN_NOT_APPLICABLE: `${homeBase}/not-applicable/user-loan-not-applicable`,
  USER_NEW_CREDIT_NOT_APPLICABLE: `${homeBase}/not-applicable/user-new-credit-not-applicable`,
}
